// src/components/ui/ThemeToggle.jsx
import React from "react";
import Icon from "./Icon";
import { useTheme } from "../../contexts/ThemeContext";

/**
 * Theme toggle. Sun icon when in dark mode (click → light), moon when
 * in light mode (click → dark). Uses inline SVG so it always renders.
 */
export default function ThemeToggle({ size = 36, className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className={`inline-flex items-center justify-center rounded-full transition-colors ${className}`}
      style={{
        width: size,
        height: size,
        background: "transparent",
        color: "var(--txt-2)",
        border: "1px solid var(--border-2)",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "var(--gold)";
        e.currentTarget.style.borderColor = "var(--gold-border)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "var(--txt-2)";
        e.currentTarget.style.borderColor = "var(--border-2)";
      }}
    >
      <Icon name={isDark ? "sun" : "moon"} size={16} />
    </button>
  );
}
